// src/utils/slugify.ts
export function slugify(text: string): string {
  return text
    .toString()
    .normalize('NFD') // 1. Split accented characters (e.g., 'é' becomes 'e' + '´')
    .replace(/[\u0300-\u036f]/g, '') // 2. Remove the separated accent marks
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars (except hyphens)
    .replace(/\-\-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '') // Trim hyphens from start
    .replace(/-+$/, ''); // Trim hyphens from end
}

export function generateUniqueSlug(baseText: string, existingSlugs: string[] = []): string {
  let slug = slugify(baseText);
  let counter = 1;
  
  while (existingSlugs.includes(slug)) {
    slug = `${slugify(baseText)}-${counter}`;
    counter++;
  }
  
  return slug;
}